module.exports = __webpack_public_path__ + "img/icon_3_2.2ea540ad.png";